const API_BASE = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5001/api';

const authHeaders = () => {
  const token = localStorage.getItem('adminToken');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

const readJson = async (res) => {
  const data = await res.json();
  if (!res.ok || !data?.success) {
    throw new Error(data?.message || 'เกิดข้อผิดพลาด');
  }
  return data;
};

export const proceedingsAPI = {
  listPublic: async (category = 'all') => {
    const query = category && category !== 'all' ? `?category=${encodeURIComponent(category)}` : '';
    const res = await fetch(`${API_BASE}/proceedings${query}`);
    return readJson(res);
  },

  getPublicById: async (id) => {
    const res = await fetch(`${API_BASE}/proceedings/${id}`);
    return readJson(res);
  },

  listAdmin: async () => {
    const res = await fetch(`${API_BASE}/proceedings/admin/list`, {
      headers: authHeaders(),
    });
    return readJson(res);
  },

  create: async (payload) => {
    const res = await fetch(`${API_BASE}/proceedings/admin`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify(payload),
    });
    return readJson(res);
  },

  update: async (id, payload) => {
    const res = await fetch(`${API_BASE}/proceedings/admin/${id}`, {
      method: 'PUT',
      headers: authHeaders(),
      body: JSON.stringify(payload),
    });
    return readJson(res);
  },

  remove: async (id) => {
    const res = await fetch(`${API_BASE}/proceedings/admin/${id}`, {
      method: 'DELETE',
      headers: authHeaders(),
    });
    return readJson(res);
  },
};
